import { EulaListSearchCriteria } from '../models/end-user-license-agreement.model';

export class EndUserLicenseAgreementListLoad {
  public static readonly type = '[EndUserLicenseAgreementList] Load';

  constructor(public payload: EulaListSearchCriteria) {}
}

export class EndUserLicenseAgreementListInitialState {
  public static readonly type = '[EndUserLicenseAgreementList] Set Initial State';
}
